import { create } from 'zustand';

interface FilterStore {
  searchQuery: string;
  statusFilter: string[];
  vendorFilter: string[];
  confidenceRange: [number, number];
  dateRange: {
    from: Date | null;
    to: Date | null;
  };
  sortBy: 'date' | 'confidence' | 'vendor';
  sortOrder: 'asc' | 'desc';
  page: number;
  pageSize: number;

  setSearchQuery: (query: string) => void;
  setStatusFilter: (statuses: string[]) => void;
  setVendorFilter: (vendors: string[]) => void;
  setConfidenceRange: (range: [number, number]) => void;
  setDateRange: (from: Date | null, to: Date | null) => void;
  setSortBy: (field: 'date' | 'confidence' | 'vendor') => void;
  setSortOrder: (order: 'asc' | 'desc') => void;
  setPage: (page: number) => void;
  setPageSize: (size: number) => void;
  reset: () => void;
}

const initialState = {
  searchQuery: '',
  statusFilter: [],
  vendorFilter: [],
  confidenceRange: [0, 100] as [number, number],
  dateRange: { from: null, to: null },
  sortBy: 'date' as const,
  sortOrder: 'desc' as const,
  page: 1,
  pageSize: 20,
};

export const useFilterStore = create<FilterStore>((set) => ({
  ...initialState,
  setSearchQuery: (query) => set({ searchQuery: query, page: 1 }),
  setStatusFilter: (statuses) => set({ statusFilter: statuses, page: 1 }),
  setVendorFilter: (vendors) => set({ vendorFilter: vendors, page: 1 }),
  setConfidenceRange: (range) => set({ confidenceRange: range, page: 1 }),
  setDateRange: (from, to) => set({ dateRange: { from, to }, page: 1 }),
  setSortBy: (field) => set({ sortBy: field }),
  setSortOrder: (order) => set({ sortOrder: order }),
  setPage: (page) => set({ page }),
  setPageSize: (size) => set({ pageSize: size, page: 1 }),
  reset: () => set(initialState),
}));
